function sendJSONData (sendScript, jsonString, success, failure) {
    let xmlhttp = new XMLHttpRequest();
    xmlhttp.addEventListener("readystatechange", (e) => {
        if (xmlhttp.readyState === 4) {
            if (xmlhttp.status === 200) {
                success(xmlhttp.responseText);
            } else {
                failure("*** Error has occured with AJAX request | " + xmlhttp.statusText);
            }
        } 
    });
    xmlhttp.addEventListener("error", (e) => {
        failure("*** Error has occured during AJAX data sending");
    });
    xmlhttp.open("POST", sendScript, true);
    xmlhttp.send(jsonString);
}

function getJSONData(retrieveScript, success, failure) {
    // send out AJAX request
    let xmlhttp = new XMLHttpRequest();
    xmlhttp.addEventListener("readystatechange", (e) => {
        if (xmlhttp.readyState === 4) {
            if (xmlhttp.status === 200) {
                // data retrieved - call success method and pass along JSON response
                //this is called responseText because if left to xml, it converts it into xml
                success(xmlhttp.responseText);
            } else {
                failure("*** Error has occured with AJAX request | " + xmlhttp.statusText);
            }
        } 
    });
    xmlhttp.addEventListener("error", (e) => {
        failure("*** Error has occured during AJAX data retrieval");
    });
    xmlhttp.open("GET", retrieveScript, true);
    xmlhttp.send();
}

export {sendJSONData, getJSONData};